import { AfterViewInit, Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreService } from 'src/app/core/services/core.service';
import { CommonModule } from '@angular/common';

import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { AuthorizerUsers, User } from 'src/app/shared/model/user.model';
import { StorageService } from 'src/app/core/storage/storage.service';
import { Vehicles } from 'src/app/shared/model/vehicle.model';
import {
  OrderInfoRequest,
  OrderRequest
} from 'src/app/shared/model/order.model';
import { ContactInfo } from 'src/app/shared/model/request-detail.model';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { GenerateNewOrderObj } from 'src/app/shared/utils/generateNewOrderObj';
import { StepperComponent } from 'src/app/shared/components/stepper/stepper.component';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { ModalConfirmRequestComponent } from 'src/app/shared/components/modal-confirm-request/modal-confirm-request.component';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  standalone: true,
  selector: 'app-general-service',
  templateUrl: './general-service.component.html',
  styleUrls: ['./general-service.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    RouterModule,
    StepperComponent,
    MatDialogModule
  ]
})
export class GeneralServiceComponent implements OnInit, AfterViewInit {
  user!: User;
  requestType = RequestType.generalServices;

  steps = new Map<string, boolean>();

  requestObj!: OrderRequest;

  vehicles?: Vehicles[];
  replacementVehicle?: Vehicles;
  origen = '';
  orderSubType = '';
  model!: string[];
  estimatedKms = 0;
  comments = '';
  retribution = '';

  controller?: AuthorizerUsers;
  authorizer?: AuthorizerUsers;
  extraEmail = '';
  extraPhone = '';
  landing2 = false;
  loading = false;

  constructor(
    private storageService: StorageService,
    private coreService: CoreService,
    public dialog: MatDialog,
    private generateNewOrderObj: GenerateNewOrderObj,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'newRequest');
    if (this.storageService.get('config')) {
      this.user = this.storageService.get('config');
    }
    this.setSteps();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('newRequest');
    }, 0);
  }

  setSteps() {
    this.steps.set('approvers', true);
    this.steps.set('request-info', true);
    this.steps.set('car-config', true);
    this.steps.set('replacementvehicle', true);
    this.steps.set('additionalInfo', true);
  }

  generateRequestObject(newRequestData: any) {
    const orderInfo: OrderInfoRequest = {
      requestType: RequestType.generalServices,
      comments: newRequestData.comments,
      controllerUserId: newRequestData.controller?.id,
      delegatedApproverUserId: newRequestData.authorizer?.id
    };

    const generalServicesData = {
      orderSubType: newRequestData.requestInfo.subtype,
      retribution: newRequestData.requestInfo.retribution,
      replacedVehicle: newRequestData.replacementVehicleInfo,
      newVehicle: newRequestData.newVehicle
        ? this.generateNewOrderObj.mapNewVehicle(newRequestData.newVehicle)
        : null,
      stockVehicle: newRequestData.stockVehicle
    };

    const phone = newRequestData.extraPhone
      ? newRequestData.extraPhone.trim()
      : null;
    const email = newRequestData.extraEmail
      ? newRequestData.extraEmail.trim()
      : null;

    let contactInfoDataDTO: ContactInfo | null = {
      phoneNumber: phone || null,
      email: email || null
    };

    if (!phone && !email) {
      contactInfoDataDTO = null;
    }

    this.requestObj = {
      orderInfo: { ...orderInfo },
      generalServicesData: { ...generalServicesData },
      contactInfoDataDTO: { ...contactInfoDataDTO }
    };
  }

  openConfirmationModal() {
    const dialogRef = this.dialog.open(ModalConfirmRequestComponent);
    dialogRef.componentInstance.submitRequestEmitter.subscribe(() => {
      this.loading = true;
      this.coreService.newOrder(this.requestObj).subscribe({
        next: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestOk'),
              redirect: true,
              list: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        },
        error: () => {
          this.loading = false;
          this.dialog.open(FeedbackModalComponent, {
            data: {
              text: i18next.t('newRequestKO'),
              close: true,
              theme: 'ligth'
            },
            disableClose: true
          });
        }
      });
    });
  }

  sendRequest(newRequestData: any) {
    this.generateRequestObject(newRequestData);
    this.openConfirmationModal();
  }
}
